// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    StripeTaxInfo,
    StripeTaxInfoFromJSON,
    StripeTaxInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaymentProfilePayload
 */
export interface PaymentProfilePayload {
    /**
     * 
     * @type {number}
     * @memberof PaymentProfilePayload
     */
    id?: number;
    /**
     * Stripe token returned by Stripe.js
     * @type {string}
     * @memberof PaymentProfilePayload
     */
    stripeToken: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentProfilePayload
     */
    users: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentProfilePayload
     */
    billingCycle: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentProfilePayload
     */
    company?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentProfilePayload
     */
    planId?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentProfilePayload
     */
    product?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentProfilePayload
     */
    email?: string;
    /**
     * (for billing)
     * @type {string}
     * @memberof PaymentProfilePayload
     */
    address?: string;
    /**
     * (for billing)
     * @type {string}
     * @memberof PaymentProfilePayload
     */
    city?: string;
    /**
     * (for billing)
     * @type {string}
     * @memberof PaymentProfilePayload
     */
    state?: string;
    /**
     * (for billing)
     * @type {string}
     * @memberof PaymentProfilePayload
     */
    country?: string;
    /**
     * (for billing)
     * @type {string}
     * @memberof PaymentProfilePayload
     */
    countryCode?: string;
    /**
     * (Zip/postal code for billing)
     * @type {string}
     * @memberof PaymentProfilePayload
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentProfilePayload
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentProfilePayload
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentProfilePayload
     */
    trial?: boolean;
    /**
     * Tax ID - like European VAT number or Canadian BN or Canadian QST number
     * @type {string}
     * @memberof PaymentProfilePayload
     */
    customerTaxId?: string;
    /**
     * 
     * @type {StripeTaxInfo}
     * @memberof PaymentProfilePayload
     */
    taxInfo?: StripeTaxInfo;
}

export function PaymentProfilePayloadFromJSON(json: any): PaymentProfilePayload {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'stripeToken': json['stripe_token'],
        'users': json['users'],
        'billingCycle': json['billing_cycle'],
        'company': !exists(json, 'company') ? undefined : json['company'],
        'planId': !exists(json, 'plan_id') ? undefined : json['plan_id'],
        'product': !exists(json, 'product') ? undefined : json['product'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'countryCode': !exists(json, 'country_code') ? undefined : json['country_code'],
        'postalCode': !exists(json, 'postal_code') ? undefined : json['postal_code'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'trial': !exists(json, 'trial') ? undefined : json['trial'],
        'customerTaxId': !exists(json, 'customer_tax_id') ? undefined : json['customer_tax_id'],
        'taxInfo': !exists(json, 'tax_info') ? undefined : StripeTaxInfoFromJSON(json['tax_info']),
    };
}

export function PaymentProfilePayloadToJSON(value?: PaymentProfilePayload): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'stripe_token': value.stripeToken,
        'users': value.users,
        'billing_cycle': value.billingCycle,
        'company': value.company,
        'plan_id': value.planId,
        'product': value.product,
        'email': value.email,
        'address': value.address,
        'city': value.city,
        'state': value.state,
        'country': value.country,
        'country_code': value.countryCode,
        'postal_code': value.postalCode,
        'phone': value.phone,
        'name': value.name,
        'trial': value.trial,
        'customer_tax_id': value.customerTaxId,
        'tax_info': StripeTaxInfoToJSON(value.taxInfo),
    };
}


